module.exports = __webpack_public_path__ + "media/img/advice/icon--takimoto-ef148c2608b6926199de52bd970ab983.png";